import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList({ page, size, symbolId }) {
    return http.get({
      url: `/api/thanos-admin/v1/admin/position/head-inch/list?page=${page}&size=${size}&symbolId=${symbolId}`,
    });
  },
  sendCoin(data) {
    return http.post({
      url: `/la/admin/send/coin/sendCoin`,
      data
    });
  },
  // sendCoin({ amount, userId }) {
  //   return http.get({
  //     url: `/la/admin/send/coin/sendCoin?amount=${amount}&userId=${userId}`,
  //   });
  // },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/rebateRate?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
};
